import styled from "styled-components"
import Spinner from "./Spinner"
import cn from "clsx"

const LoadingContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  &.full-screen {
    width: 100vw;
    height: 100vh;
  }
`

interface Props {
  fullScreen?: boolean
}

const LoadingSpinner = (props: Props) => {
  const { fullScreen = true } = props

  return (
    <LoadingContainer className={cn({ "full-screen": fullScreen })}>
      <Spinner className="primary-dark size-large" />
    </LoadingContainer>
  )
}

export default LoadingSpinner
